import type { AxiosResponse } from "axios";

import type {
  AiReputationReport,
  AiReputationReportSummary,
  CommercialContext,
  CommercialContextRequest,
} from "../types/aiReputation";
import { api } from "../utils/apiClient";

export const getCommercialContext = (
  signal?: AbortSignal,
): Promise<AxiosResponse<CommercialContext>> =>
  api.get("/user/hotel-commercial-context", false, { signal });

export const saveCommercialContext = (
  request: CommercialContextRequest,
): Promise<AxiosResponse<CommercialContext>> => api.put("/user/hotel-commercial-context", request);

export const createAiReputationReport = (name = ""): Promise<AxiosResponse<AiReputationReport>> =>
  api.post("/ai-reputation-reports", { name });

export const listAiReputationReports = (): Promise<AxiosResponse<AiReputationReportSummary[]>> =>
  api.get("/ai-reputation-reports");

export const getAiReputationReport = (
  reportId: string,
  signal?: AbortSignal,
): Promise<AxiosResponse<AiReputationReport>> =>
  api.get(`/ai-reputation-reports/${encodeURIComponent(reportId)}`, false, { signal });
